<template>
	<div style="margin-left: 10px;" :style="[{height: `${ height }`}]">
		<!-- 基本通用表格 -->
		<template v-if="colnum == 7">
			<div class="all">
				<el-table ref="multipleTable"  border @sort-change="changeTableSort"
					@cell-dblclick="copyText" :cell-style="{ padding: '0px' }"
					:style="[{fontSize: `${ fontSizeTable }px`},{width: `${ width }`}]" :span-method="objectSpanMethod"
					:data="tableData" header-row-tyle="height:12px;" :row-class-name="tableRowClassName7"
					@selection-change="handleSelectionChange" highlight-current-row @row-click="onRowClick">
					<template v-for="(item , index) of headerData">
						<el-table-column v-if="item.types==='selection'" :fixed="item.fixed" type="selection"
							width="55" />
						<el-table-column v-else :show-overflow-tooltip='true' :fixed="item.fixed" :key="index+'7'"
							:prop="item.prop" :label="item.label" :width="item.columnwidth" :type="item.types">
							<template slot-scope="scope">
								<span v-if="item.prop==='id'"
									:style="{color:getColor(scope.row)}">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='ManuDate'">
									<span v-if="scope.row.ManuDate">
										{{`${ scope.row.ManuDate }`.substring(0,10) == null ? "" : `${ scope.row.ManuDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='SBDate'">
									<span v-if="scope.row.SBDate">
										{{`${ scope.row.SBDate }`.substring(0,10) == null ? "" : `${ scope.row.SBDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='ValiDate'">
									<span v-if="scope.row.ValiDate">
										{{`${ scope.row.ValiDate }`.substring(0,10) == null ? "" : `${ scope.row.ValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CheckTime'">
									<span v-if="scope.row.CheckTime">
										{{`${ scope.row.CheckTime }`.substring(0,10) == null ? "" : `${ scope.row.CheckTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='UnitPrice'" class="UnitPriceCss">
									<span v-if="scope.row.UnitPrice">
										{{ scope.row.UnitPrice }}
									</span>
								</span>
								<span v-else-if="item.prop==='Quantity'" class="UnitPriceCss">
									{{ scope.row.Quantity }}
								</span>
								<span v-else-if="item.prop==='InvClassName'" :style="{color:getColor(scope.row)}">
									{{ scope.row.InvClassName }}
								</span>
								<span v-else-if="item.prop==='DetailRemark'">
									{{ scope.row.DetailRemark }}
									<input v-if="!DetailRemarkdisabled" type="text" v-model="scope.row.DetailRemark" class="cell-input" />
								</span>
								<span
									v-else-if="item.prop==='TaxUnitPriceSum'">{{ (scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2)}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'" class="UnitPriceCss">
									<span v-if="scope.row.TaxUnitPrice != null">
										{{ scope.row.TaxUnitPrice }}
									</span>
								</span>
								<span v-else-if="item.prop==='dDate'">
									<span v-if="scope.row.dDate">
										{{`${ scope.row.dDate }`.substring(0,10) == null ? "" : `${ scope.row.dDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='dmodifysystime'">
									<span v-if="scope.row.dmodifysystime">
										{{`${ scope.row.dmodifysystime }`.substring(0,10) == null ? "" : `${ scope.row.dmodifysystime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='dDLDate'">
									<span v-if="scope.row.dDLDate">
										{{`${ scope.row.dDLDate }`.substring(0,10) == null ? "" : `${ scope.row.dDLDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='SynTime'">
									<span v-if="scope.row.SynTime">
										{{`${ scope.row.SynTime }`.substring(0,10) == null ? "" : `${ scope.row.SynTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='RejectTime'">
									<span v-if="scope.row.RejectTime">
										{{`${ scope.row.RejectTime }`.substring(0,10) == null ? "" : `${ scope.row.RejectTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='dcreatesystime'">
									<span v-if="scope.row.dcreatesystime">
										{{`${ scope.row.dcreatesystime }`.substring(0,10) == null ? "" : `${ scope.row.dcreatesystime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='dverifydate'">
									<span v-if="scope.row.dverifydate">
										{{`${ scope.row.dverifydate }`.substring(0,10) == null ? "" : `${ scope.row.dverifydate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'" :style="{color:getColor(scope.row)}">
									<span v-if="scope.row.CreateTime">
										{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='UpdateTime'" :style="{color:getColor(scope.row)}">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VerifyTime'">
									<span v-if="scope.row.VerifyTime">
										{{`${ scope.row.VerifyTime }`.substring(0,10) == null ? "" : `${ scope.row.VerifyTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='DPDate'">
									<span v-if="scope.row.DPDate">
										{{`${ scope.row.DPDate }`.substring(0,10) == null ? "" : `${ scope.row.DPDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='TaxPrice'" class="UnitPriceCss">
									<span v-if="scope.row.TaxPrice !== null">
										{{ scope.row.TaxPrice }}
									</span>
								</span>
								<span v-else-if="item.prop==='Money'" class="UnitPriceCss">
									<span v-if="scope.row.Money !== null">
										{{ scope.row.Money  }}
									</span>
								</span>
								<span v-else-if="item.prop==='Sum'" class="UnitPriceCss">
									<span v-if="scope.row.Sum">
										{{ scope.row.Sum }}
									</span>
								</span>
								<span v-else-if="item.prop==='NatSum'" class="UnitPriceCss">
									<span v-if="scope.row.NatSum">
										{{ scope.row.NatSum }}
									</span>
								</span>
								<span v-else-if="item.prop==='NatMoney'" class="UnitPriceCss">
									<span v-if="scope.row.NatMoney">
										{{ scope.row.NatMoney  }}
									</span>
								</span>
								<span v-else-if="item.prop==='BillQuantity'" class="UnitPriceCss">
									{{ scope.row.BillQuantity  }}
								</span>
								<span v-else-if="item.prop==='NatTaxPrice'" class="UnitPriceCss">
									<span v-if="scope.row.NatTaxPrice">
										{{ scope.row.NatTaxPrice  }}
									</span>
								</span>
								<span
									v-else-if="item.prop==='Disabled' || item.prop==='IsBarCodeControl' || item.prop==='Actived' || item.prop==='Consignment'">
									<img src="../assets/icon/iocn-seccess.png" style="width: 14.17px;height: 14.17px;"
										v-if="scope.row.Disabled == 1 || scope.row.IsBarCodeControl == 1 || scope.row.Actived == 1 || scope.row.Consignment == 1" />
									<img src="../assets/icon/icon-error.png" style="width: 14.17px;height: 14.17px;"
										v-else />
								</span>
								<!-- 表格列表下拉 -->
								<span v-else-if="item.prop==='PTA高压球囊扩张导管'">
									<el-select v-model="scope.row.PTA高压球囊扩张导管Options.selected" clearable
										placeholder="请选择" :disabled="PTAOptionsDisabled">
										<el-option v-for="item in scope.row.PTA高压球囊扩张导管Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='PTA球囊扩张导管'">
									<el-select v-model="scope.row.PTA球囊扩张导管Options.selected" clearable placeholder="请选择"
										:disabled="HPOptionsDisabled">
										<el-option v-for="item in scope.row.PTA球囊扩张导管Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='腔静脉滤器抓捕器'">
									<el-select v-model="scope.row.腔静脉滤器抓捕器Options.selected" clearable placeholder="请选择"
										:disabled="DCBOptionsDisabled">
										<el-option v-for="item in scope.row.腔静脉滤器抓捕器Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='外周球囊扩张导管'">
									<el-select v-model="scope.row.外周球囊扩张导管Options.selected" clearable placeholder="请选择"
										:disabled="GCOptionsDisabled">
										<el-option v-for="item in scope.row.外周球囊扩张导管Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='药物洗脱PTA球囊扩张导管'">
									<el-select v-model="scope.row.药物洗脱PTA球囊扩张导管Options.selected" clearable
										placeholder="请选择" :disabled="YCXOptionsDisabled">
										<el-option v-for="item in scope.row.药物洗脱PTA球囊扩张导管Options.options"
											:key="item.key" :label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='抓捕器'">
									<el-select v-model="scope.row.抓捕器Options.selected" clearable placeholder="请选择"
										:disabled="QSZJOptionsDisabled">
										<el-option v-for="item in scope.row.抓捕器Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='弹簧圈系统'">
									<el-select v-model="scope.row.弹簧圈系统Options.selected" clearable placeholder="请选择"
										:disabled="THQOptionsDisabled">
										<el-option v-for="item in scope.row.弹簧圈系统Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='球囊导引导管'">
									<el-select v-model="scope.row.球囊导引导管Options.selected" clearable placeholder="请选择"
										:disabled="PQDYGptionsDisabled">
										<el-option v-for="item in scope.row.球囊导引导管Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>

								<span v-else-if="item.prop==='远端通路导引导管'">
									<el-select v-model="scope.row.远端通路导引导管Options.selected" clearable placeholder="请选择"
										:disabled="YDTLDYGptionsDisabled">
										<el-option v-for="item in scope.row.远端通路导引导管Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='颅内支持导管'">
									<el-select v-model="scope.row.颅内支持导管Options.selected" clearable placeholder="请选择"
										:disabled="LNZCDGptionsDisabled">
										<el-option v-for="item in scope.row.颅内支持导管Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='颅内支撑导管'">
									<el-select v-model="scope.row.颅内支撑导管Options.selected" clearable placeholder="请选择"
										:disabled="LNZZDGptionsDisabled">
										<el-option v-for="item in scope.row.颅内支撑导管Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='颅内球囊扩张导管'">
									<el-select v-model="scope.row.颅内球囊扩张导管Options.selected" clearable placeholder="请选择"
										:disabled="LNQNKZDGptionsDisabled">
										<el-option v-for="item in scope.row.颅内球囊扩张导管Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='取栓支架'">
									<el-select v-model="scope.row.取栓支架Options.selected" clearable placeholder="请选择"
										:disabled="LNQNKZDGptionsDisabled">
										<el-option v-for="item in scope.row.取栓支架Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>
								<span v-else-if="item.prop==='一次性使用微导管'">
									<el-select v-model="scope.row.一次性使用微导管Options.selected" clearable placeholder="请选择"
										:disabled="LNQNKZDGptionsDisabled">
										<el-option v-for="item in scope.row.一次性使用微导管Options.options" :key="item.key"
											:label="item.value" :value="item.key">
										</el-option>
									</el-select>
								</span>

								<span v-else-if="item.prop==='Look'">
									<a style="" class="aclick" @click="Look(scope.$index, scope.row)">查看</a>
								</span>

								<span v-else-if="item.prop==='File'">
									<img src="@/assets/channel/DownLoadIcon/Ex_File.png" alt=""
										style="width: 16px; height: 16px;" v-if="scope.row.File == 'xlsl'">
									<img src="@/assets/channel/DownLoadIcon/O_File.png" alt=""
										style="width: 16px; height: 16px;" v-if="scope.row.File == 'OutLook'">
									<img src="@/assets/channel/DownLoadIcon/P_File.png" alt=""
										style="width: 16px; height: 16px;" v-if="scope.row.File == 'ppt'">
									<img src="@/assets/channel/DownLoadIcon/Word_File.png" alt=""
										style="width: 16px; height: 16px;" v-if="scope.row.File == 'docx'">
									<img src="@/assets/channel/DownLoadIcon/Pdf_File.png" alt=""
										style="width: 16px; height: 16px;" v-else-if="scope.row.File == 'pdf'">
								</span>
								<!-- 操作(删除、修改、审核，等。) -->
								<span v-else-if="item.prop==='czAll'">
									<span v-for="(item , index) of scope.row.czAll" :key="index">
										<a style="" v-if="item.BtnFalg" class="aclick"
											@click="CZClick(scope.$index, scope.row , item)">{{item.title}}</a>
									</span>
								</span>

								<span v-else-if="item.prop==='Download'">
									<a class="aclick" @click="Download(scope.$index, scope.row)">下载</a>
								</span>
								<span v-else-if="item.prop==='CanUpload'">
									<!--上传 -->
									<a class="aclick"
										:style="{color: scope.row.TrialFeedbackSubmittedStatus=='未上传'?'red':''}"
										v-if="!scope.row.CanUpload" @click.stop="">
										{{scope.row.TrialFeedbackSubmittedStatus}}
									</a>
									<CommonbtnUpLoad v-else style="margin: 0px !important;" backgroundColor="#FFF"
										title="上传" types="UploadAll" :uploadType="3" fontSize="14px" opwidth="130px"
										color="red" @getFiles="UploadFiles($event,scope.$index, scope.row)">
									</CommonbtnUpLoad>
								</span>
								<span v-else-if="item.prop==='CanConfirm'">
									<a class="aclick" :class="[!scope.row.CanConfirm?'disabled':'']"
										@click.stop="Confirm(scope.$index, scope.row)">确认</a>
								</span>
								<span v-else-if="item.prop==='cc'">
									<a class="operation" @click="operation">{{ scope.row.cc  }}</a>
								</span>
								<span v-else-if="item.prop==='Attachment'">
									<span v-if="scope.row.Attachment.Download">
										<a class="operation"
											@click="operationDownload(scope.row)">{{ scope.row.Attachment.Download  }}</a>
									</span>
									<span v-if="scope.row.Attachment.ReasonText">
										<a class="operation"
											@click="ReasonTips(scope.row)">{{ scope.row.Attachment.ReasonText  }}</a>
									</span>
								</span>
								<span v-else-if="item.prop.includes('DetailRemark')">
									<input type="text" v-model="scope.row[item.prop]" class="item-input" />
								</span>
								<span v-else-if="item.prop.includes('row_')">
									{{scope.row[item.prop]}}
									<span style="color:red;" v-if="scope.row[item.prop+'_trend']===1">↑</span>
									<span style="color:green;" v-if="scope.row[item.prop+'_trend']===0">↓</span>
								</span>
								<span v-else-if="item.prop==='CusNameGif'">
									{{scope.row[item.prop]}}
									<img v-if="scope.row.HasDownload==0" src="../static/new-gif.gif" />
								</span>
								<span v-else-if="item.types==='html'" v-html="scope.row[item.prop]"></span>
								<span :style="{color:getCellColor(item,scope.row)}"
									v-else>{{ parseText(item.prop,scope.row)}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == '5-sort'">
			<div class="all">
				<el-table :style="{width: `${ width }`}"  @sort-change="changeTableSort"
					@cell-dblclick="copyText" :row-key="RowKeyIDsSelect522" border ref="fileTableSelect"
					@selection-change="handleSelectionChange" :data="tableData" header-row-tyle="height:12px;"
					:row-style="rowClassSelect" :row-class-name="tableRowClassName" :cell-style="{padding:'0px'}"
					highlight-current-row @row-click="onRowClick">
					<el-table-column :show-overflow-tooltip='true' type="selection" :reserve-selection="true">
					</el-table-column>
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'5-sort'" :sortable="item.sortable"
							:prop="item.prop" :fixed="item.fixed" :label="item.label" :width="item.columnwidth"
							:row-class-name="tableRowClassName522" highlight-current-row @row-click="onRowClick">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'">
									{{ scope.row.TaxUnitPrice }}
									<input type="text" v-model="scope.row.TaxUnitPrice" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='Quantity'">
									{{ scope.row.Quantity }}
									<input type="text" v-model="scope.row.Quantity" class="cell-input"
										@input="Quantity522($event,scope.row.Quantity)" />
								</span>
								<span v-else-if="item.prop==='InvCode'">
									{{ scope.row.InvCode }}
									<input type="text" v-model="scope.row.InvCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvName'">
									{{ scope.row.InvName }}
									<input type="text" v-model="scope.row.InvName" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<!---->
								<span
									v-else-if="item.prop==='TaxUnitPriceSum'">{{ (scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2)  }}</span>
								<span v-else-if="item.prop==='OperateName'">
									<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
										@click="cz(scope.row.ID)">{{ scope.row.OperateName }}</a>
								</span>
								<span v-else-if="item.prop==='ManuDate'">
									<span v-if="scope.row.ManuDate">
										{{`${ scope.row.ManuDate }`.substring(0,10) == null ? "" : `${ scope.row.ManuDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='SBDate'">
									<span v-if="scope.row.SBDate">
										{{`${ scope.row.SBDate }`.substring(0,10) == null ? "" : `${ scope.row.SBDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='RejectTime'">
									<span v-if="scope.row.RejectTime">
										{{`${ scope.row.RejectTime }`.substring(0,10) == null ? "" : `${ scope.row.RejectTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'">
									<span v-if="scope.row.CreateTime">
										{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VouchValiDate'">
									<span v-if="scope.row.VouchValiDate">
										{{`${ scope.row.VouchValiDate }`.substring(0,10) == null ? "" : `${ scope.row.VouchValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='Total'" class="UnitPriceCss">
									{{ scope.row.Total }}
								</span>

								<span v-else-if="item.prop==='ValiDate'">
									<span v-if="scope.row.ValiDate">
										{{`${ scope.row.ValiDate }`.substring(0,10) == null ? "" : `${ scope.row.ValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='StartDate'">
									<span v-if="scope.row.StartDate">
										{{`${ scope.row.StartDate }`.substring(0,10) == null ? "" : `${ scope.row.StartDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='EndDate'">
									<span v-if="scope.row.EndDate">
										{{`${ scope.row.EndDate }`.substring(0,10) == null ? "" : `${ scope.row.EndDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='ActiveTime'">
									<span v-if="scope.row.ActiveTime">
										{{`${ scope.row.ActiveTime }`.substring(0,10) == null ? "" : `${ scope.row.ActiveTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='TVDate'">
									<span v-if="scope.row.TVDate">
										{{`${ scope.row.TVDate }`.substring(0,10) == null ? "" : `${ scope.row.TVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VerifyTime'">
									<span v-if="scope.row.VerifyTime">
										{{`${ scope.row.VerifyTime }`.substring(0,10) == null ? "" : `${ scope.row.VerifyTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='Doctor'">
									{{ scope.row.Doctor }}
									<input type="text" v-model="scope.row.Doctor" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='TechnicalOffices'">
									{{ scope.row.TechnicalOffices }}
									<input type="text" v-model="scope.row.TechnicalOffices" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='SurgeryCountPerYear'">
									{{ scope.row.SurgeryCountPerYear }}
									<input type="text" v-model="scope.row.SurgeryCountPerYear" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='IsTOP'">
									<span v-if="scope.row.IsTOP == 0">
										否
									</span>
									<span v-else-if="scope.row.IsTOP == 1">
										是
									</span>
								</span>
								<span v-else-if="item.prop==='Operate'">
									<a style="" class="aclick" @click="Look(scope.$index, scope.row)">查看</a>
									<a class="aclick" @click="Download(scope.$index, scope.row)">下载</a>
									<a class="aclick" @click="PrintClick(scope.$index, scope.row)">打印</a>
								</span>
								<span
									v-else-if="item.prop==='Disabled' || item.prop==='IsBarCodeControl' || item.prop==='Actived' || item.prop==='Consignment' || item.prop==='Enabled'">
									<img src="../assets/icon/iocn-seccess.png" style="width: 14.17px;height: 14.17px;"
										v-if="scope.row.Disabled == 1 || scope.row.IsBarCodeControl == 1 || scope.row.Actived == 1 || scope.row.Enabled == 1" />
									<img src="../assets/icon/icon-error.png" style="width: 14.17px;height: 14.17px;"
										v-else />
								</span>
								<span v-else-if="item.prop==='Attachment'">
									<span v-if="item.par == 'Extension' && scope.row.Attachment">
										<img src="@/assets/channel/DownLoadIcon/Ex_File.png" alt=""
											style="width: 20px; height: 20px; margin-top: 8px;"
											v-if="scope.row.Attachment.Extension == 'xlsx'">
										<img src="@/assets/channel/DownLoadIcon/O_File.png" alt=""
											style="width: 20px; height: 20px;margin-top: 8px;"
											v-else-if="scope.row.Attachment.Extension == 'OutLook'">
										<img src="@/assets/channel/DownLoadIcon/P_File.png" alt=""
											style="width: 20px; height: 20px;margin-top: 8px;"
											v-else-if="scope.row.Attachment.Extension == 'ppt'">
										<img src="@/assets/channel/DownLoadIcon/Word_File.png" alt=""
											style="width: 20px; height: 20px;margin-top: 8px;"
											v-else-if="scope.row.Attachment.Extension == 'docx'">
										<img src="@/assets/channel/DownLoadIcon/Pdf_File.png" alt=""
											style="width: 20px; height: 20px;margin-top: 8px;"
											v-if="scope.row.Attachment.Extension == 'pdf'">
									</span>

									<span v-else-if="item.par == 'FileName'  && scope.row.Attachment">
										{{scope.row.Attachment.FileName}}
									</span>
								</span>
								<span v-else>{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>

		<template v-if="colnum == 81">
			<div class="all">
				<el-table ref="multipleTable" border  @sort-change="changeTableSort"
					@cell-dblclick="copyText" :row-key="RowKeys81" :span-method="objectSpanMethod" :data="tableData"
					header-row-tyle="height:12px;" :row-class-name="tableRowClassName" :cell-style="{padding:'0px'}"
					@selection-change="handleSelectionChange" highlight-current-row @row-click="onRowClick">
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'81'" :prop="item.prop"
							:label="item.label" :width="item.columnwidth" :type="item.types">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span
									v-else-if="item.prop==='Disabled' || item.prop==='IsBarCodeControl' || item.prop==='Actived' || item.prop==='Consignment'">
									<img src="../assets/icon/iocn-seccess.png" style="width: 14.17px;height: 14.17px;"
										v-if="scope.row.Disabled == 1 || scope.row.IsBarCodeControl == 1 || scope.row.Actived == 1" />
									<img src="../assets/icon/icon-error.png" style="width: 14.17px;height: 14.17px;"
										v-else />
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'">
									<span v-if="scope.row.CreateTime">
										{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else>{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 100">
			<div class="all">
				<table border="1" style=" border-color: #f0f0f0;color: #000;overflow-y: scroll;height: 500px;"
					:style="[{width: `${ width }`},{height: `${ height }`}]" :cell-style="{padding:'0px'}">
					<thead>
						<tr>
							<th style="width: 100px;"> 错误信息</th>
							<th colspan="2"></th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,index) of tableData" :key="index">
							<td style="padding-left: 10px;">{{ index+1 }}</td>
							<td style="padding-left: 10px;">{{ item }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</template>
		<template v-if="colnum == 300">
			<div class="all">
				<div class="tips" style="font-size: 16px;padding-bottom:12px;">
					因归创通桥产品--{{tableData&&tableData.map(it=>`【${it.InvName}】`).join('、')}} 包装的特殊性<br />
					请按如下规则做鸿雁系统报量：
				</div>
				<table border="1" style=" border-color: #f0f0f0;color: #000;overflow-y: scroll;height: 500px;"
					:style="[{width: `${ width }`},{height: `${ height }`}]" :cell-style="{padding:'0px'}">
					<thead>
						<tr>
							<th style="width: 120px;text-align: left;padding-left: 10px;"> 产品名称</th>
							<th style="width: 120px;text-align: left;padding-left: 10px;"> 规格</th>
							<th style="width: 300px;text-align: left;padding-left: 10px;"> 系统报量规则</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(item,index) of tableData" :key="index">
							<td style="width: 120px;padding-left: 10px;">{{ item.InvName }}</td>
							<td style="width: 120px;padding-left: 10px;">{{ item.InvStd }}</td>
							<td style="width: 300px;padding-left: 10px;">{{ item.Prompt }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</template>
		<template v-if="colnum == 5">
			<div class="all">
				<el-table :style="{width: `${ width }`}"  border ref="fileTable"
					@selection-change="handleSelectionChange" @cell-dblclick="copyText" :data="tableData"
					header-row-tyle="height:12px;" :row-style="rowClass" :row-class-name="tableRowClassName"
					:cell-style="{padding:'0px'}" highlight-current-row @row-click="onRowClick">
					<el-table-column type="selection" :reserve-selection="false">
					</el-table-column>
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'5'" :fixed="item.fixed"
							:prop="item.prop" :label="item.label" :width="item.columnwidth"
							:row-class-name="tableRowClassName" highlight-current-row @row-click="onRowClick">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'">
									{{ scope.row.TaxUnitPrice == null ? "" : scope.row.TaxUnitPrice }}
									<input type="text" :disabled="Quantityflag" v-model="scope.row.TaxUnitPrice"
										class="cell-input" @change="TaxUnitPriceChange($event,scope.row)" />
								</span>
								<span v-else-if="item.prop==='Quantity'">
									{{ scope.row.Quantity }}
									<input type="text" v-model="scope.row.Quantity" class="cell-input"
										:disabled="Quantityflag" @input="Quantity522($event,scope.row.Quantity)" />
								</span>
								<span v-else-if="item.prop==='InvCode'">
									{{ scope.row.InvCode }}
									<input type="text" v-model="scope.row.InvCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvName'">
									{{ scope.row.InvName }}
									<input type="text" v-model="scope.row.InvName" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<!-- <span v-else-if="item.prop==='InvName'">
                  <input type="text" v-model="scope.row.InvName" class="cell-input" v-if="InvoiceChecked == -1" />
                </span> -->
								<span v-else-if="item.prop==='TaxUnitPriceSum'">
									<template v-if="!isZheRan">
										{{ (scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2) }}
									</template>
									<template v-else>
										{{ scope.row.Sum }}
										<input type="text" v-model="scope.row.Sum" class="cell-input"
											@input="zheRChange($event,scope.row)" />
									</template>
								</span>
								<span v-else-if="item.prop==='ManuDate'">
									<span v-if="scope.row.ManuDate">
										{{`${ scope.row.ManuDate }`.substring(0,10) == null ? "" : `${ scope.row.ManuDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='SBDate'">
									<span v-if="scope.row.SBDate">
										{{`${ scope.row.SBDate }`.substring(0,10) == null ? "" : `${ scope.row.SBDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='ValiDate'">
									<span v-if="scope.row.ValiDate">
										{{`${ scope.row.ValiDate }`.substring(0,10) == null ? "" : `${ scope.row.ValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'">
									<span v-if="scope.row.CreateTime">
										{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='ActiveTime'">
									<span v-if="scope.row.ActiveTime">
										{{`${ scope.row.ActiveTime }`.substring(0,10) == null ? "" : `${ scope.row.ActiveTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VerifyTime'">
									<span v-if="scope.row.VerifyTime">
										{{`${ scope.row.VerifyTime }`.substring(0,10) == null ? "" : `${ scope.row.VerifyTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='EndDate'">
									<span v-if="scope.row.EndDate">
										{{`${ scope.row.EndDate }`.substring(0,10) == null ? "" : `${ scope.row.EndDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='OperateName'">
									<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
										@click="cz(scope.row.ID)">{{ scope.row.OperateName }}</a>
								</span>
								<span v-else-if="item.prop==='operationBtn'">
									<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
									<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
										删除</el-button>
								</span>
								<span v-else-if="item.prop==='Operate'">
									<a style="" class="aclick" @click="Look(scope.$index, scope.row)">查看</a>
									<a class="aclick" @click="Download(scope.$index, scope.row)">下载</a>
									<a class="aclick" @click="PrintClick(scope.$index, scope.row)">打印</a>
								</span>
								<span v-else-if="item.prop==='czAll'">
									<span v-for="(item , index) of scope.row.czAll" :key="index">
										<a style="" v-if="item.BtnFalg
                  " class="aclick" @click="item.clickName(scope.$index, scope.row)">{{item.title}}</a>
									</span>
								</span>
								<span v-else-if="item.prop==='File'">
									<img src="@/assets/channel/DownLoadIcon/Ex_File.png" alt=""
										style="width: 20px; height: 20px; margin-top: 8px;"
										v-if="scope.row.File == 'xlsl'">
									<img src="@/assets/channel/DownLoadIcon/O_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-if="scope.row.File == 'OutLook'">
									<img src="@/assets/channel/DownLoadIcon/P_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-if="scope.row.File == 'ppt'">
									<img src="@/assets/channel/DownLoadIcon/Word_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-if="scope.row.File == 'docx'">
									<img src="@/assets/channel/DownLoadIcon/Pdf_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-if="scope.row.File == 'pdf'">
								</span>
								<span v-else-if="item.prop.includes('DetailRemark')||item.edit">
									<input type="text" v-model="scope.row[item.prop]" class="item-input" />
								</span>
								<span v-else :style="{color:textColor(scope.row)}">{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>

		<template v-if="colnum == 533">
			<div class="all">
				<el-table :style="{width: `${ width }`}"  border ref="fileTable"
					@cell-dblclick="copyText" @selection-change="handleSelectionChangeUNQ" :data="tableData"
					header-row-tyle="height:12px;" :row-style="rowClass" :row-class-name="tableRowClassName"
					:cell-style="{padding:'0px'}" highlight-current-row @row-click="onRowClick">
					<el-table-column type="selection" :reserve-selection="false">
					</el-table-column>
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'533'" :prop="item.prop"
							:label="item.label" :width="item.columnwidth" :row-class-name="tableRowClassName"
							highlight-current-row @row-click="onRowClick">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'">
									{{ scope.row.TaxUnitPrice }}
									<input type="text" v-model="scope.row.TaxUnitPrice" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='Quantity'">
									{{ scope.row.Quantity }}
									<input type="text" v-model="scope.row.Quantity" class="cell-input"
										@input="Quantity522($event,scope.row.Quantity)" />
								</span>
								<span v-else-if="item.prop==='InvCode'">
									{{ scope.row.InvCode }}
									<input type="text" v-model="scope.row.InvCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvName'">
									{{ scope.row.InvName }}
									<input type="text" v-model="scope.row.InvName" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<!-- <span v-else-if="item.prop==='InvName'">
                  <input type="text" v-model="scope.row.InvName" class="cell-input" v-if="InvoiceChecked == -1" />
                </span> -->
								<span
									v-else-if="item.prop==='TaxUnitPriceSum'">{{ (scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2)}}</span>
								<span v-else-if="item.prop==='OperateName'">
									<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
										@click="cz(scope.row.ID)">{{ scope.row.OperateName }}</a>
								</span>
								<span v-else-if="item.prop==='ManuDate'">
									<span v-if="scope.row.ManuDate">
										{{`${ scope.row.ManuDate }`.substring(0,10) == null ? "" : `${ scope.row.ManuDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='SBDate'">
									<span v-if="scope.row.SBDate">
										{{`${ scope.row.SBDate }`.substring(0,10) == null ? "" : `${ scope.row.SBDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'">
									<span v-if="scope.row.CreateTime">
										{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
									</span>
								</span>
								<!-- <span v-else-if="item.prop==='SBDate'">
                  <span v-if="scope.row.SBDate">
                    {{`${ scope.row.SBDate }`.substring(0,10) == null ? "" : `${ scope.row.SBDate }`.substring(0,10)}}
                  </span>
                </span> -->
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VouchValiDate'">
									<span v-if="scope.row.VouchValiDate">
										{{`${ scope.row.VouchValiDate }`.substring(0,10) == null ? "" : `${ scope.row.VouchValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='Total'" class="UnitPriceCss">
									{{ scope.row.Total }}
								</span>

								<span v-else-if="item.prop==='ValiDate'">
									<span v-if="scope.row.ValiDate">
										{{`${ scope.row.ValiDate }`.substring(0,10) == null ? "" : `${ scope.row.ValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='ActiveTime'">
									<span v-if="scope.row.ActiveTime">
										{{`${ scope.row.ActiveTime }`.substring(0,10) == null ? "" : `${ scope.row.ActiveTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='TVDate'">
									<span v-if="scope.row.TVDate">
										{{`${ scope.row.TVDate }`.substring(0,10) == null ? "" : `${ scope.row.TVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VerifyTime'">
									<span v-if="scope.row.VerifyTime">
										{{`${ scope.row.VerifyTime }`.substring(0,10) == null ? "" : `${ scope.row.VerifyTime }`.substring(0,10)}}
									</span>
								</span>
								<span
									v-else-if="item.prop==='Disabled' || item.prop==='IsBarCodeControl' || item.prop==='Actived' || item.prop==='Consignment' || item.prop==='Enabled'">
									<img src="../assets/icon/iocn-seccess.png" style="width: 14.17px;height: 14.17px;"
										v-if="scope.row.Disabled == 1 || scope.row.IsBarCodeControl == 1 || scope.row.Actived == 1 || scope.row.Enabled == 1" />
									<img src="../assets/icon/icon-error.png" style="width: 14.17px;height: 14.17px;"
										v-else />
								</span>
								<span v-else>{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 522">
			<div class="all">
				<!-- :cell-style="{padding:'0px'}" -->
				<el-table :style="{width: `${ width }`}"  :row-key="RowKeyIDsSelect522"
					@cell-dblclick="copyText" border ref="fileTableSelect" @selection-change="handleSelectionChange"
					:data="tableData" header-row-tyle="height:12px;" :row-style="rowClassSelect"
					:row-class-name="tableRowClassName522" :cell-style="cellStyle" highlight-current-row
					@row-click="onRowClick">
					<el-table-column :show-overflow-tooltip='true' type="selection" :reserve-selection="true">
					</el-table-column>
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'522'" :prop="item.prop"
							:fixed="item.fixed" :label="item.label" :width="item.columnwidth"
							:row-class-name="tableRowClassName522" highlight-current-row @row-click="onRowClick">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'">
									{{ scope.row.TaxUnitPrice }}
									<input type="text" v-model="scope.row.TaxUnitPrice" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='RepeatMessage'" style="color:red !important">
									{{ scope.row.RepeatMessage }}
								</span>
								<span v-else-if="item.prop==='Quantity'">
									{{ scope.row.Quantity }}
									<input type="text" v-model="scope.row.Quantity" class="cell-input"
										@input="Quantity522($event,scope.row.Quantity)" />
								</span>
								<span v-else-if="item.prop==='InvCode'">
									{{ scope.row.InvCode }}
									<input type="text" v-model="scope.row.InvCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvName'">
									{{ scope.row.InvName }}
									<input type="text" v-model="scope.row.InvName" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>

								<span
									v-else-if="item.prop==='TaxUnitPriceSum'">{{(scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2)}}</span>
								<span v-else-if="item.prop==='OperateName'">
									<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
										@click="cz(scope.row.ID)">查看</a>
								</span>
								<span v-else-if="item.prop==='OperateNameT'">
									<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
										@click="czs(scope.row.ID)">审批详情</a>
								</span>
								<span v-else-if="item.prop==='ManuDate'">
									<span v-if="scope.row.ManuDate">
										{{`${ scope.row.ManuDate }`.substring(0,10) == null ? "" : `${ scope.row.ManuDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='SBDate'">
									<span v-if="scope.row.SBDate">
										{{`${ scope.row.SBDate }`.substring(0,10) == null ? "" : `${ scope.row.SBDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='RejectTime'">
									<span v-if="scope.row.RejectTime">
										{{`${ scope.row.RejectTime }`.substring(0,10) == null ? "" : `${ scope.row.RejectTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'">
									<span v-if="scope.row.CreateTime">
										<span v-if="item.options">
											<span v-if="item.options.type == '备案'">
												{{`${ scope.row.CreateTime }`.substring(0,16) == null ? "" : `${ scope.row.CreateTime }`.substring(0,16)}}
											</span>
										</span>
										<span v-else>
											{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
										</span>
									</span>
								</span>
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VouchValiDate'">
									<span v-if="scope.row.VouchValiDate">
										{{`${ scope.row.VouchValiDate }`.substring(0,10) == null ? "" : `${ scope.row.VouchValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='Total'" class="UnitPriceCss">
									{{ scope.row.Total }}
								</span>

								<span v-else-if="item.prop==='ValiDate'">
									<span v-if="scope.row.ValiDate">
										{{`${ scope.row.ValiDate }`.substring(0,10) == null ? "" : `${ scope.row.ValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='StartDate'">
									<span v-if="scope.row.StartDate">
										{{`${ scope.row.StartDate }`.substring(0,10) == null ? "" : `${ scope.row.StartDate }`.substring(0,10)}}
									</span>
								</span>
								<!-- <span v-else-if="item.prop==='SBDate'">
                  <span v-if="scope.row.SBDate">
                    {{`${ scope.row.SBDate }`.substring(0,10) == null ? "" : `${ scope.row.SBDate }`.substring(0,10)}}
                  </span>
                </span> -->

								<span v-else-if="item.prop==='EndDate'">
									<span v-if="scope.row.EndDate">
										{{`${ scope.row.EndDate }`.substring(0,10) == null ? "" : `${ scope.row.EndDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='ActiveTime'">
									<span v-if="scope.row.ActiveTime">
										{{`${ scope.row.ActiveTime }`.substring(0,10) == null ? "" : `${ scope.row.ActiveTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='TVDate'">
									<span v-if="scope.row.TVDate">
										{{`${ scope.row.TVDate }`.substring(0,10) == null ? "" : `${ scope.row.TVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VerifyTime'">
									<span v-if="scope.row.VerifyTime">
										{{`${ scope.row.VerifyTime }`.substring(0,10) == null ? "" : `${ scope.row.VerifyTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='Doctor'">
									{{ scope.row.Doctor }}
									<input type="text" v-model="scope.row.Doctor" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='TechnicalOffices'">
									{{ scope.row.TechnicalOffices }}
									<input type="text" v-model="scope.row.TechnicalOffices" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='SurgeryCountPerYear'">
									{{ scope.row.SurgeryCountPerYear }}
									<input type="text" v-model="scope.row.SurgeryCountPerYear" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='NeedShowOffice'">
									<!-- {{}} -->
									<el-checkbox :value="scope.row.NeedShowOffice?true:false"
										@change="handckChange($event,scope.row)">
									</el-checkbox>
								</span>
								<!--配送商-->
								<span v-else-if="item.prop==='Dispatcher'">
									{{ scope.row.Dispatcher }}
									<input type="text" v-model="scope.row.Dispatcher" class="cell-input" />
								</span>
								<!--备注-->
								<span v-else-if="item.prop==='DetailRemark'">
									{{ scope.row.DetailRemark }}
									<input type="text" v-model="scope.row.DetailRemark" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='DispatcherTypeName'">
									{{scope.row.DispatcherType&&scope.row.DispatcherType!='null'?item.options[item.options.findIndex(it=>it.key==scope.row.DispatcherType)].value:''}}
									<el-select v-model="scope.row.DispatcherType" class="cell-input" clearable
										placeholder="请选择">
										<el-option v-for="(it,ix) in item.options" :key="ix" :label="it.value"
											:value="it.key" />
									</el-select>
								</span>
								<span v-else-if="item.prop==='IsTOP'">
									<span v-if="scope.row.IsTOP == 0">
										否
									</span>
									<span v-else-if="scope.row.IsTOP == 1">
										是
									</span>
								</span>
								<!-- 操作(删除、修改、审核，等。) -->
								<span v-else-if="item.prop==='czAll'">
									<span v-for="(item , index1) of scope.row.czAll" :key="index1+'652'">
										<a style="" v-if="item.BtnFalg" class="aclick"
											@click="CZClick(scope.$index, scope.row , item)">{{item.title}}</a>
									</span>
								</span>
								<span v-else-if="item.prop==='Operate'">
									<a style="" class="aclick" @click="Look(scope.$index, scope.row)">查看</a>
									<a class="aclick" @click="Download(scope.$index, scope.row)">下载</a>
									<a class="aclick" @click="PrintClick(scope.$index, scope.row)">打印</a>
								</span>
								<span
									v-else-if="item.prop==='Disabled' || item.prop==='IsBarCodeControl' || item.prop==='Actived' || item.prop==='Consignment' || item.prop==='Enabled'">
									<img src="../assets/icon/iocn-seccess.png" style="width: 14.17px;height: 14.17px;"
										v-if="scope.row.Disabled == 1 || scope.row.IsBarCodeControl == 1 || scope.row.Actived == 1 || scope.row.Enabled == 1" />
									<img src="../assets/icon/icon-error.png" style="width: 14.17px;height: 14.17px;"
										v-else />
								</span>
								<span v-else-if="item.prop==='Attachment'">
									<span v-if="item.par == 'Extension' && scope.row.Attachment">
										<img src="@/assets/channel/DownLoadIcon/Ex_File.png" alt=""
											style="width: 20px; height: 20px; margin-top: 8px;"
											v-if="scope.row.Attachment.Extension == 'xlsx'">
										<img src="@/assets/channel/DownLoadIcon/O_File.png" alt=""
											style="width: 20px; height: 20px;margin-top: 8px;"
											v-else-if="scope.row.Attachment.Extension == 'OutLook'">
										<img src="@/assets/channel/DownLoadIcon/P_File.png" alt=""
											style="width: 20px; height: 20px;margin-top: 8px;"
											v-else-if="scope.row.Attachment.Extension == 'ppt'">
										<img src="@/assets/channel/DownLoadIcon/Word_File.png" alt=""
											style="width: 20px; height: 20px;margin-top: 8px;"
											v-else-if="scope.row.Attachment.Extension == 'docx'">
										<img src="@/assets/channel/DownLoadIcon/Pdf_File.png" alt=""
											style="width: 20px; height: 20px;margin-top: 8px;"
											v-if="scope.row.Attachment.Extension == 'pdf'">
									</span>

									<span v-else-if="item.par == 'FileName'  && scope.row.Attachment">
										{{scope.row.Attachment.FileName}}
									</span>
								</span>
								<span v-else>{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 555">
			<div class="all">
				<el-table class="customer-no-border-table"  :row-key="RowKeyIDsSelect556"
					@cell-dblclick="copyText" :style="{width: `${ width }`}" ref="fileTable555"
					@selection-change="handleSelectionChange" :data="tableData" header-row-tyle="height:12px;"
					:row-style="rowClass" :row-class-name="tableRowClassName" :cell-style="{padding:'0px'}"
					highlight-current-row @row-click="onRowClick555">
					<el-table-column type="selection" :reserve-selection="true" :width="widthselection">
					</el-table-column>
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'555'" :fixed="item.fixed"
							:prop="item.prop" :label="item.label" :width="item.columnwidth"
							:row-class-name="tableRowClassName" highlight-current-row @row-click="onRowClick">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'">
									{{ scope.row.TaxUnitPrice == null ? "" : scope.row.TaxUnitPrice }}
									<input type="text" v-model="scope.row.TaxUnitPrice" class="cell-input"
										@change="TaxUnitPriceChange($event,scope.row)" />
								</span>
								<span v-else-if="item.prop==='Quantity'">
									{{ scope.row.Quantity }}
									<input type="text" v-model="scope.row.Quantity" class="cell-input"
										:disabled="Quantityflag" />
								</span>
								<span v-else-if="item.prop==='InvCode'">
									{{ scope.row.InvCode }}
									<input type="text" v-model="scope.row.InvCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvName'">
									{{ scope.row.InvName }}
									<input type="text" v-model="scope.row.InvName" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<!-- <span v-else-if="item.prop==='InvName'">
                  <input type="text" v-model="scope.row.InvName" class="cell-input" v-if="InvoiceChecked == -1" />
                </span> -->
								<span
									v-else-if="item.prop==='TaxUnitPriceSum'">{{ (scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2)}}</span>
								<span v-else-if="item.prop==='ManuDate'">
									<span v-if="scope.row.ManuDate">
										{{`${ scope.row.ManuDate }`.substring(0,10) == null ? "" : `${ scope.row.ManuDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='ValiDate'">
									<span v-if="scope.row.ValiDate">
										{{`${ scope.row.ValiDate }`.substring(0,10) == null ? "" : `${ scope.row.ValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'">
									<span v-if="scope.row.CreateTime">
										{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='ActiveTime'">
									<span v-if="scope.row.ActiveTime">
										{{`${ scope.row.ActiveTime }`.substring(0,10) == null ? "" : `${ scope.row.ActiveTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VerifyTime'">
									<span v-if="scope.row.VerifyTime">
										{{`${ scope.row.VerifyTime }`.substring(0,10) == null ? "" : `${ scope.row.VerifyTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='EndDate'">
									<span v-if="scope.row.EndDate">
										{{`${ scope.row.EndDate }`.substring(0,10) == null ? "" : `${ scope.row.EndDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='OperateName'">
									<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
										@click="cz(scope.row.ID)">{{ scope.row.OperateName }}</a>
								</span>
								<span v-else-if="item.prop==='operationBtn'">
									<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
									<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
										删除</el-button>
								</span>
								<span v-else-if="item.prop==='Operate'">
									<a style="" class="aclick" @click="Look(scope.$index, scope.row)">查看</a>
									<a class="aclick" @click="Download(scope.$index, scope.row)">下载</a>
									<a class="aclick" @click="PrintClick(scope.$index, scope.row)">打印</a>
								</span>
								<span v-else-if="item.prop==='File'">
									<img src="@/assets/channel/DownLoadIcon/Ex_File.png" alt=""
										style="width: 20px; height: 20px; margin-top: 8px;"
										v-if="scope.row.File == 'xlsl'">
									<img src="@/assets/channel/DownLoadIcon/O_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-if="scope.row.File == 'OutLook'">
									<img src="@/assets/channel/DownLoadIcon/P_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-if="scope.row.File == 'ppt'">
									<img src="@/assets/channel/DownLoadIcon/Word_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-if="scope.row.File == 'docx'">
									<img src="@/assets/channel/DownLoadIcon/Pdf_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-else-if="scope.row.Attachment.Extension == 'pdf'">
								</span>
								<span v-else-if="item.types==='html'" v-html="scope.row[item.prop]"></span>
								<span v-else>{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 556">
			<div class="all">
				<el-table class="customer-no-border-table"  :style="{width: `${ width }`}"
					@cell-dblclick="copyText" ref="fileTable556" @selection-change="handleSelectionChange"
					:data="tableData" header-row-tyle="height:12px;" :row-style="rowClass"
					:row-class-name="tableRowClassName" :cell-style="{padding:'0px'}" highlight-current-row
					@row-click="onRowClick556">
					<el-table-column type="selection" :reserve-selection="false" :width="widthselection">
					</el-table-column>
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'556'" :fixed="item.fixed"
							:prop="item.prop" :label="item.label" :width="item.columnwidth"
							:row-class-name="tableRowClassName" highlight-current-row @row-click="onRowClick">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'">
									{{ scope.row.TaxUnitPrice == null ? "" : scope.row.TaxUnitPrice }}
									<input type="text" v-model="scope.row.TaxUnitPrice" class="cell-input"
										@change="TaxUnitPriceChange($event,scope.row)" />
								</span>
								<span v-else-if="item.prop==='Quantity'">
									{{ scope.row.Quantity }}
									<input type="text" v-model="scope.row.Quantity" class="cell-input"
										:disabled="Quantityflag" />
								</span>
								<span v-else-if="item.prop==='InvCode'">
									{{ scope.row.InvCode }}
									<input type="text" v-model="scope.row.InvCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvName'">
									{{ scope.row.InvName }}
									<input type="text" v-model="scope.row.InvName" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<!-- <span v-else-if="item.prop==='InvName'">
                  <input type="text" v-model="scope.row.InvName" class="cell-input" v-if="InvoiceChecked == -1" />
                </span> -->
								<span
									v-else-if="item.prop==='TaxUnitPriceSum'">{{ (scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2)}}</span>
								<span v-else-if="item.prop==='ManuDate'">
									<span v-if="scope.row.ManuDate">
										{{`${ scope.row.ManuDate }`.substring(0,10) == null ? "" : `${ scope.row.ManuDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='ValiDate'">
									<span v-if="scope.row.ValiDate">
										{{`${ scope.row.ValiDate }`.substring(0,10) == null ? "" : `${ scope.row.ValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'">
									<span v-if="scope.row.CreateTime">
										{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='ActiveTime'">
									<span v-if="scope.row.ActiveTime">
										{{`${ scope.row.ActiveTime }`.substring(0,10) == null ? "" : `${ scope.row.ActiveTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VerifyTime'">
									<span v-if="scope.row.VerifyTime">
										{{`${ scope.row.VerifyTime }`.substring(0,10) == null ? "" : `${ scope.row.VerifyTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='EndDate'">
									<span v-if="scope.row.EndDate">
										{{`${ scope.row.EndDate }`.substring(0,10) == null ? "" : `${ scope.row.EndDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='OperateName'">
									<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
										@click="cz(scope.row.ID)">{{ scope.row.OperateName }}</a>
								</span>
								<span v-else-if="item.prop==='operationBtn'">
									<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
									<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">
										删除</el-button>
								</span>
								<span v-else-if="item.prop==='Operate'">
									<a style="" class="aclick" @click="Look(scope.$index, scope.row)">查看</a>
									<a class="aclick" @click="Download(scope.$index, scope.row)">下载</a>
									<a class="aclick" @click="PrintClick(scope.$index, scope.row)">打印</a>
								</span>
								<span v-else-if="item.prop==='File'">
									<img src="@/assets/channel/DownLoadIcon/Ex_File.png" alt=""
										style="width: 20px; height: 20px; margin-top: 8px;"
										v-if="scope.row.File == 'xlsl'">
									<img src="@/assets/channel/DownLoadIcon/O_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-if="scope.row.File == 'OutLook'">
									<img src="@/assets/channel/DownLoadIcon/P_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-if="scope.row.File == 'ppt'">
									<img src="@/assets/channel/DownLoadIcon/Word_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-if="scope.row.File == 'docx'">
									<img src="@/assets/channel/DownLoadIcon/Pdf_File.png" alt=""
										style="width: 20px; height: 20px;margin-top: 8px;"
										v-else-if="scope.row.File == 'pdf'">
								</span>
								<span v-else>{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 511">
			<div class="all">
				<el-table :style="{width: `${ width }`}"  :row-key="RowKeysSelect"
					@cell-dblclick="copyText" border ref="fileTableSelect" @selection-change="handleSelectionChange"
					:data="tableData" header-row-tyle="height:12px;" :row-style="rowClassSelect"
					:row-class-name="tableRowClassName" :cell-style="{padding:'0px'}" highlight-current-row
					@row-click="onRowClick">
					<el-table-column :show-overflow-tooltip='true' type="selection" :reserve-selection="true">
					</el-table-column>
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'511'" :fixed="item.fixed"
							:prop="item.prop" :label="item.label" :width="item.columnwidth"
							:row-class-name="tableRowClassName" highlight-current-row @row-click="onRowClick">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'"><input type="text"
										v-model="scope.row.TaxUnitPrice" class="cell-input" /> </span>
								<span v-else-if="item.prop==='Quantity'">
									<input type="text" v-model="scope.row.Quantity" class="cell-input" />
								</span>
								<span v-else-if="item.prop==='InvCode'">
									<input type="text" v-model="scope.row.InvCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvName'">
									<input type="text" v-model="scope.row.InvName" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<!-- <span v-else-if="item.prop==='InvName'">
                  <input type="text" v-model="scope.row.InvName" class="cell-input" v-if="InvoiceChecked == -1" />
                </span> -->
								<span
									v-else-if="item.prop==='TaxUnitPriceSum'">{{(scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2)}}</span>
								<!-- <span v-else-if="item.prop==='InvoiceCheckedName'">
                  <span v-show="scope.row.InvoiceCheckedName == '发票照片已上传未通过'" style="display: inline-block;color: red;">
                    {{ scope.row.InvoiceCheckedName }}
                  </span>
                  <span v-show="scope.row.InvoiceCheckedName == '未上传发票照片'" style="display: inline-block;color: #C0696B;">
                    {{ scope.row.InvoiceCheckedName }}
                  </span>
                  <span v-show="scope.row.InvoiceCheckedName == '发票照片已上传已验证'">
                    {{ scope.row.InvoiceCheckedName }}
                  </span>
                </span> -->
								<span v-else-if="item.prop==='OperateName'">
									<a style="display: inline-block;font-size: 12px;margin-left: 10px;color: #00266D;text-decoration: underline;cursor: pointer;"
										@click="cz(scope.row.ID)">{{ scope.row.OperateName }}</a>
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CheckTime'">
									<span v-if="scope.row.CheckTime">
										{{`${ scope.row.CheckTime }`.substring(0,10) == null ? "" : `${ scope.row.CheckTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='SBDate'">
									<span v-if="scope.row.SBDate">
										{{`${ scope.row.SBDate }`.substring(0,10) == null ? "" : `${ scope.row.SBDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='DPDate'">
									<span v-if="scope.row.DPDate">
										{{`${ scope.row.DPDate }`.substring(0,10) == null ? "" : `${ scope.row.DPDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='SurgeryDate'">
									<span v-if="scope.row.SurgeryDate">
										{{`${ scope.row.SurgeryDate }`.substring(0,10) == null ? "" : `${ scope.row.SurgeryDate }`.substring(0,10)}}
									</span>
								</span>

								<!-- <span v-else-if="item.prop==='CreateTime'">
                  <span v-if="scope.row.CreateTime">
                    {{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
                  </span>
                </span> -->
								<span v-else-if="item.prop==='Operate'">
									<a style="" class="aclick" @click="Look(scope.$index, scope.row)">查看</a>
									<a class="aclick" @click="Download(scope.$index, scope.row)">下载</a>
									<a class="aclick" @click="PrintClick(scope.$index, scope.row)">打印</a>
									<a class="aclick" v-if="auth.update"
										@click="RemarkClick(scope.$index, scope.row)">备注</a>
								</span>
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else>{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 56">
			<div class="all">
				<!-- {{tableData}} -->
				<el-table :style="{width: `${ width }`}"  ref="table56" @cell-dblclick="copyText"
					:row-key="RowKeys" border :data="tableData" header-row-tyle="height:12px;" :row-style="rowClass"
					:row-class-name="tableRowClassName" :cell-style="{padding:'0px'}" highlight-current-row
					@row-click="onRowClick">
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'56'" :prop="item.prop"
							:label="item.label" :width="item.columnwidth" :row-class-name="tableRowClassName"
							highlight-current-row @row-click="onRowClick">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'" class="UnitPriceCss">
									<input type="text" v-model="scope.row.TaxUnitPrice" class="cell-input" />
									{{ `${ scope.row.TaxUnitPrice }`.substring(0,`${ scope.row.TaxUnitPrice }`.indexOf(".") + 3) }}
								</span>
								<span v-else-if="item.prop==='Quantity'" class="UnitPriceCss">
									<input type="text" v-model="scope.row.Quantity"
										:disabled="scope.row.disabledQuantity" class="cell-input"
										v-if="wtype == 0 && tableflag == true" />
									{{ scope.row.Quantity }}
								</span>
								<span v-else-if="item.prop==='InvCode'">
									{{ scope.row.InvCode }}
									<input type="text" v-model="scope.row.InvCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvName'">
									{{ scope.row.InvName }}
									<input type="text" v-model="scope.row.InvName" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<!-- <span v-else-if="item.prop==='InvName'">
                  <input type="text" v-model="scope.row.InvName" class="cell-input" v-if="InvoiceChecked == -1" />
                </span> -->
								<span
									v-else-if="item.prop==='TaxUnitPriceSum'">{{ (scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2)}}</span>
								<!-- <span v-else-if="item.prop==='InvoiceCheckedName'">
                  <span v-show="scope.row.InvoiceCheckedName == '发票照片已上传未通过'" style="display: inline-block;color: red;">
                    {{ scope.row.InvoiceCheckedName }}
                  </span>
                  <span v-show="scope.row.InvoiceCheckedName == '未上传发票照片'" style="display: inline-block;color: #C0696B;">
                    {{ scope.row.InvoiceCheckedName }}
                  </span>
                  <span v-show="scope.row.InvoiceCheckedName == '发票照片已上传已验证'">
                    {{ scope.row.InvoiceCheckedName }}
                  </span>
                </span> -->
								<span v-else-if="item.prop==='Sum'" class="UnitPriceCss">
									{{ `${ scope.row.TaxUnitPrice * scope.row.Quantity}`.substring(0,`${ scope.row.Sum }`.indexOf(".") + 3) }}
								</span>
								<span v-else-if="item.prop==='ValiDate'">
									<span v-if="scope.row.ValiDate !== null">
										{{`${ scope.row.ValiDate }`.substring(0,10) == null ? "" : `${ scope.row.ValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'">
									<span v-if="scope.row.CreateTime">
										{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else>{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 57">
			<div class="all">
				<!-- {{tableData}} -->

				<el-table :style="{width: `${ width }`}"  ref="table57" @cell-dblclick="copyText"
					:row-key="RowKeys" border @selection-change="handleSelectionChange" :data="tableData"
					header-row-tyle="height:12px;" :row-style="rowClass" :row-class-name="tableRowClassName"
					:cell-style="{padding:'0px'}" highlight-current-row @row-click="onRowClick">
					<el-table-column type="selection" :reserve-selection="true">
					</el-table-column>
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'57'" :prop="item.prop"
							:label="item.label" :width="item.columnwidth" :row-class-name="tableRowClassName"
							highlight-current-row @row-click="onRowClick">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'"><input type="text"
										v-model="scope.row.TaxUnitPrice" class="cell-input" /> </span>
								<span v-else-if="item.prop==='Quantity'" class="UnitPriceCss">
									{{ scope.row.Quantity }}
									<input type="text" v-model="scope.row.Quantity"
										:disabled="scope.row.disabledQuantity" class="cell-input"
										v-if="wtype == 0 && tableflag == true" />
								</span>
								<span v-else-if="item.prop==='InvCode'">
									{{ scope.row.InvCode }}
									<input type="text" v-model="scope.row.InvCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvName'">
									{{ scope.row.InvName }}
									<input type="text" v-model="scope.row.InvName" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<!-- <span v-else-if="item.prop==='InvName'">
                  <input type="text" v-model="scope.row.InvName" class="cell-input" v-if="InvoiceChecked == -1" />
                </span> -->
								<span
									v-else-if="item.prop==='TaxUnitPriceSum'">{{ (scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2)}}</span>
								<!-- <span v-else-if="item.prop==='InvoiceCheckedName'">
                  <span v-show="scope.row.InvoiceCheckedName == '发票照片已上传未通过'" style="display: inline-block;color: red;">
                    {{ scope.row.InvoiceCheckedName }}
                  </span>
                  <span v-show="scope.row.InvoiceCheckedName == '未上传发票照片'" style="display: inline-block;color: #C0696B;">
                    {{ scope.row.InvoiceCheckedName }}
                  </span>
                  <span v-show="scope.row.InvoiceCheckedName == '发票照片已上传已验证'">
                    {{ scope.row.InvoiceCheckedName }}
                  </span>
                </span> -->
								<span v-else-if="item.prop==='ValiDate'">
									<span v-if="scope.row.ValiDate !== null">
										{{`${ scope.row.ValiDate }`.substring(0,10) == null ? "" : `${ scope.row.ValiDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'">
									<span v-if="scope.row.CreateTime">
										{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else>{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 51">
			<div class="all">
				<el-table :style="{width: `${ width }`}"  @cell-dblclick="copyText"
					:row-key="RowKeys" border @selection-change="handleSelectionChange" :data="tableData"
					header-row-tyle="height:12px;" :row-style="rowClass" :row-class-name="tableRowClassName"
					:cell-style="{padding:'0px'}" highlight-current-row @row-click="onRowClick">
					<el-table-column type="selection" :reserve-selection="true">
					</el-table-column>
					<template v-for="(item , index) of headerData">
						<el-table-column :show-overflow-tooltip='true' :key="index+'51'" :prop="item.prop"
							:label="item.label" :width="item.columnwidth" :row-class-name="tableRowClassName"
							highlight-current-row @row-click="onRowClick">
							<template slot-scope="scope">
								<span
									v-if="item.prop==='id'">{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
								<span v-else-if="item.prop==='TaxUnitPrice'"><input type="text"
										v-model="scope.row.TaxUnitPrice" class="cell-input"
										v-if="InvoiceChecked == -1" /> </span>
								<span v-else-if="item.prop==='Quantity'"> <input type="text"
										v-model="scope.row.Quantity" class="cell-input" v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvCode'">
									<input type="text" v-model="scope.row.InvCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='InvName'">
									<input type="text" v-model="scope.row.InvName" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='Batch'">
									<input type="text" v-model="scope.row.Batch" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='ValiDate'">
									<input type="text" v-model="scope.row.ValiDate" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='VouCode'">
									<input type="text" v-model="scope.row.VouCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span v-else-if="item.prop==='VouDCode'">
									<input type="text" v-model="scope.row.VouDCode" class="cell-input"
										v-if="InvoiceChecked == -1" />
								</span>
								<span
									v-else-if="item.prop==='TaxUnitPriceSum'">{{ (scope.row.TaxUnitPrice * scope.row.Quantity).toFixed(2)}}</span>
								<span v-else-if="item.prop==='VoucherMDate'">
									<span v-if="scope.row.VoucherMDate">
										{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseMDate'">
									<span v-if="scope.row.LicenseMDate">
										{{`${ scope.row.LicenseMDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseMDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='LicenseVDate'">
									<span v-if="scope.row.LicenseVDate">
										{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='VoucherVDate'">
									<span v-if="scope.row.VoucherVDate">
										{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='CreateTime'">
									<span v-if="scope.row.CreateTime">
										{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else-if="item.prop==='UpdateTime'">
									<span v-if="scope.row.UpdateTime">
										{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
									</span>
								</span>
								<span v-else>{{scope.row[item.prop]}}</span>
							</template>
						</el-table-column>
					</template>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 9">
			<div class="all">
				<el-table border :data="tableData"  @cell-dblclick="copyText"
					header-row-tyle="height:12px;" highlight-current-row :row-style="{height:`${ height }`}"
					:cell-style="{padding:'0px'}" @row-click="onRowClick">
					<el-table-column :show-overflow-tooltip='true' prop="id" label="序号" width="50">
						<template slot-scope="scope">
							<span>{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
						</template>
					</el-table-column>

					<el-table-column prop="UserName" label="用户名" width="150">
					</el-table-column>

					<el-table-column prop="TrueName" label="名字" width="160">
					</el-table-column>

					<el-table-column prop="RoleName" label="角色" width="150">
					</el-table-column>

					<el-table-column prop="Gender" label="性别" width="50">
						<template slot-scope="scope">
							<div v-if="scope.row.Gender == '1'">男</div>
							<div v-else>女</div>
						</template>
					</el-table-column>

					<el-table-column prop="Birthday" label="出生日期" width="180">
						<template slot-scope="scope">
							<span v-if="scope.row.Birthday !== null">
								{{`${ scope.row.Birthday }`.substring(0,10) == null ? "" : `${ scope.row.Birthday }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>

					<el-table-column prop="InActive" label="是否可用" width="120">
						<template slot-scope="scope">
							<img src="../assets/icon/iocn-seccess.png" style="width: 14.17px;height: 14.17px;"
								v-if="scope.row.InActive == 1" />
							<img src="../assets/icon/icon-error.png" style="width: 14.17px;height: 14.17px;" v-else />
						</template>
					</el-table-column>

					<el-table-column prop="IsOperator" label="是否操作员" width="120">
						<template slot-scope="scope">
							<img src="../assets/icon/iocn-seccess.png" style="width: 14.17px;height: 14.17px;"
								v-if="scope.row.IsOperator == 1" />
							<img src="../assets/icon/icon-error.png" style="width: 14.17px;height: 14.17px;" v-else />
						</template>
					</el-table-column>

					<el-table-column prop="Creator" label="创建人" width="380">
					</el-table-column>
				</el-table>
			</div>
		</template>

		<template v-if="colnum == 8">
			<div class="all">
				<table :data="tableData" :headerData="headerData"
					:style="[{width: `${ width }`},{height: `${ height }`}]" :cell-style="{padding:'0px'}">
					<thead>
						<tr>
							<th v-for="(item , index) of headerData" :key="index">{{ item.label }}</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(items , indexs) of tableData" :key="indexs"
							:class="[{ 'activetable': indexs == onchage }]" @click="tableclick(indexs,items)">
							<td>{{ items.id }}</td>
							<td>{{ items.stase }}</td>
							<td>{{ items.dealerstorage }}</td>
							<td>{{ items.productline }}</td>
							<td>{{ items.onedealerstorage }}</td>
							<td v-if="items.onedealerstorage1 == 1"><img src="../assets/icon/iocn-seccess.png"
									style="width: 14.17px;height: 14.17px;" /></td>
							<td v-else><img src="../assets/icon/icon-error.png"
									style="width: 14.17px;height: 14.17px;" />
							</td>
							<td v-if="items.onedealerstorageon == 1"><img src="../assets/icon/iocn-seccess.png"
									style="width: 14.17px;height: 14.17px;" /></td>
							<td v-else><img src="../assets/icon/icon-error.png"
									style="width: 14.17px;height: 14.17px;" />
							</td>
							<td>{{ items.cjtype }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</template>

		<template v-if="colnum == 3">
			<el-table border @cell-dblclick="copyText"  :data="tableData"
				header-row-tyle="height:12px;" :row-style="{height:`${ height }`}" :cell-style="{padding:'0px'}">

				<el-table-column prop="id" label="序号" width="80">
					<template slot-scope="scope">
						<span>{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
					</template>
				</el-table-column>

				<el-table-column prop="ImageUrlPath" label="缩略图" width="140">
					<template slot-scope="scope">
						<!-- config.http_URL+ -->
						<img v-if="scope.row.ImageUrlPath.includes('.pdf')" src="../static/pdf.png"
							style="width: 80px;height: 80px;margin-top: 8px;"
							@click="showPdf(scope.row.ImageUrlPath)" />
						<img v-else :src="scope.row.ImageUrlPath" style="width: 80px;height: 80px;margin-top: 8px;"
							@click="phonts(scope.row.ImageUrlPath)" />
					</template>
				</el-table-column>
				<el-table-column prop="CheckType" label="校验类型" width="300">
				</el-table-column>
				<el-table-column prop="ImageType" label="消息" width="300">
					<template slot-scope="scope">
						<span v-if="scope.row.ImageType == '发票照片'">
							<span v-if="CusFlag == 1">
								<a @click="GetTextClick">查看明细</a>
							</span>

							<span v-if="scope.row.ErrMessage != ''">
								<el-tooltip class="item" effect="dark" :content="scope.row.ErrMessage"
									placement="top-end">
									<a>报错信息</a>
								</el-tooltip>
							</span>
							<span v-else>
								<a>报错信息</a>
							</span>
						</span>
						<span v-if="scope.row.ImageType == '销货清单'">
							<a>缩略图</a>
							<a>提交时间</a>
						</span>
						<DialogFrom v-if="scope.row.GetText" width="648px" title="发票解析明细查看"
							:dialogVisible="dialogVisiblesGetText" @cancel="cancelGetText" @dialogOK="dialogOKGetText">
							<json-viewer :value="JSON.parse(scope.row.GetText)" :expand-depth=5 copyable boxed sort>
							</json-viewer>
						</DialogFrom>
					</template>
				</el-table-column>
				<el-table-column label="照片类型" width="201" prop="ImageType">
				</el-table-column>
				<el-table-column label="操作" width="330">
					<template slot-scope="scope">
						<span v-if="scope.row.ImageType == '销货清单'">
							<a @click="InvDel(scope.row.SBPDID)">删除</a>
						</span>
					</template>
				</el-table-column>
			</el-table>
		</template>
		<template v-if="colnum == 22">
			<div class="all">
				<el-table border :data="tableData"  header-row-tyle="height:12px;"
					@cell-dblclick="copyText" :row-style="{height:`${ height }`}" :cell-style="{padding:'0px'}"
					:row-class-name="tableRowClassName" @row-click="onRowClick"
					@selection-change="handleSelectionChange()" highlight-current-row>
					<el-table-column prop="id" label="序号" width="50">
						<template slot-scope="scope">
							<span>{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
						</template>
					</el-table-column>

					<el-table-column :show-overflow-tooltip='true' prop="CompanyID" label="公司编码" width="80">

					</el-table-column>

					<el-table-column :show-overflow-tooltip='true' prop="CompanyName" label="公司名称" width="174">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="AbbName" label="简称" width="150">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="ParentId" label="父级编码" width="80">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="CompanyID" label="公司编码" width="80">

					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="MarkupRate" label="加价系数" width="80">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="AutoOutToIn" label="下游自动入库" width="110">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.AutoOutToIn" :true-label="1" :false-label="0" disabled>
							</el-checkbox>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="Actived" label="是否启用" width="80">
						<template slot-scope="scope">
							<img src="../assets/icon/iocn-seccess.png" style="width: 14.17px;height: 14.17px;"
								v-if="scope.row.Actived == 1" />
							<img src="../assets/icon/icon-error.png" style="width: 14.17px;height: 14.17px;" v-else />
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="U8AccId" label="U8账套号" width="100" />
					<el-table-column :show-overflow-tooltip='true' prop="LicenseNo" label="经营许可证" width="100">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="LicenseMDate" label="经营许可证有效开始日期" width="180">
						<template slot-scope="scope">
							<span v-if="scope.row.ActiveTime !== null">
								{{`${ scope.row.ActiveTime }`.substring(0,10) == null ? "" : `${ scope.row.ActiveTime }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="VoucherNo" label="备案凭证编号" width="120">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="LicenseVDate" label="经营许可证有效结束日期" width="180">
						<template slot-scope="scope">
							<span v-if="scope.row.LicenseVDate !== null">
								{{`${ scope.row.LicenseVDate }`.substring(0,10) == null ? "" : `${ scope.row.LicenseVDate }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="VoucherMDate" label="备案凭证有效起始日期" width="180">
						<template slot-scope="scope">
							<span v-if="scope.row.VoucherMDate !== null">
								{{`${ scope.row.VoucherMDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherMDate }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="VoucherVDate" label="备案凭证有效结束日期" width="180">
						<template slot-scope="scope">
							<span v-if="scope.row.VoucherVDate !== null">
								{{`${ scope.row.VoucherVDate }`.substring(0,10) == null ? "" : `${ scope.row.VoucherVDate }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="CompanyInCharge" label="企业负责人" width="100">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="BusinessAddress" label="经营地址" width="150">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="CompanyInLaw" label="法人代表" width="80">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="WarehouseAddress" label="仓库地址" width="150">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="Password" label="密码" width="100">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="Creator" label="创建人" width="100">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="CreateTime" label="创建时间" width="160">
						<template slot-scope="scope">
							<span v-if="scope.row.CreateTime !== null">
								{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="Updater" label="修改人" width="160">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="UpdateTime" label="修改时间" width="160">
						<template slot-scope="scope">
							<span v-if="scope.row.UpdateTime !== null">
								{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="Activor" label="停启用人" width="160">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="ActiveTime" label="停启用时间" width="160">
						<template slot-scope="scope">
							<span v-if="scope.row.ActiveTime !== null">
								{{`${ scope.row.ActiveTime }`.substring(0,10) == null ? "" : `${ scope.row.ActiveTime }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 33">
			<div class="all">
				<el-table border :data="tableData"  header-row-tyle="height:12px;"
					@cell-dblclick="copyText" :row-style="{height:`${ height }`}" :cell-style="{padding:'0px'}"
					@selection-change="handleSelectionChange()" highlight-current-row @row-click="onRowClick">

					<el-table-column prop="id" label="序号" width="50">
						<template slot-scope="scope">
							<span>{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
						</template>
					</el-table-column>

					<el-table-column :show-overflow-tooltip='true' prop="Actived" label="是否启用" width="80">
						<template slot-scope="scope">
							<img src="../assets/icon/iocn-seccess.png" style="width: 16px;height: 16px;"
								v-if="scope.row.Actived == 1" />
							<img src="../assets/icon/icon-error.png" style="width: 16px;height: 16px;" v-else />
						</template>
					</el-table-column>

					<el-table-column :show-overflow-tooltip='true' prop="InvAddCode" label="产品代码" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="InvName" label="存货名称" width="150">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="InvClass" label="产线编码" width="80">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="InvClassName" label="产线名称" width="80">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="UnitName" label="计量单位" width="80">
					</el-table-column>

					<el-table-column :show-overflow-tooltip='true' prop="InvStd" label="规格型号" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="InvDescribe" label="产品描述" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="MFName" label="生产厂商" width="100">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="StorageCondition" label="储运条件" width="80">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="RegistrationNo" label="注册证号" width="200">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="ProductionLicenseNo" label="生产许可证" width="280">
					</el-table-column>

					<el-table-column :show-overflow-tooltip='true' prop="NationABCSort" label="全国ABC分类" width="80">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="IsBatchManagement" label="是否批号管理" width="80">
						<template slot-scope="scope">
							<span v-if="scope.row.IsBatchManagement == 1">是</span>
							<span v-else>否</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="IsQGManagement" label="是否有效期管理" width="150">
						<template slot-scope="scope">
							<span v-if="scope.row.IsQGManagement == 1">是</span>
							<span v-else>否</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="RefCost" label="参考成本" width="80">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="RefPrice" label="参考售价" width="80">
					</el-table-column>

					<el-table-column :show-overflow-tooltip='true' prop="StandardCost" label="标准货值" width="80">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="LEVEL1" label="LEVEL1" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="LEVEL1_5" label="LEVEL1.5" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="LEVEL2" label="LEVEL2" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="LEVEL3" label="LEVEL3" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="LEVEL4" label="LEVEL4" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="GTIN" label="GTIN" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="Creator" label="创建人" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="CreateTime" label="创建时间" width="130">
						<template slot-scope="scope">
							<span v-if="scope.row.CreateTime !== null">
								{{`${ scope.row.CreateTime }`.substring(0,10) == null ? "" : `${ scope.row.CreateTime }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="Updater" label="变更人" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="UpdateTime" label="变更时间" width="130">
						<template slot-scope="scope">
							<span v-if="scope.row.UpdateTime !== null">
								{{`${ scope.row.UpdateTime }`.substring(0,10) == null ? "" : `${ scope.row.UpdateTime }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="Activor" label="停启用人" width="130">
					</el-table-column>
					<el-table-column :show-overflow-tooltip='true' prop="ActiveTime" label="停启用时间" width="130">
						<template slot-scope="scope">
							<span v-if="scope.row.ActiveTime !== null">
								{{`${ scope.row.ActiveTime }`.substring(0,10) == null ? "" : `${ scope.row.ActiveTime }`.substring(0,10)}}
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</template>
		<template v-if="colnum == 34">
			<div class="all">
				<el-table border :data="tableData"  header-row-tyle="height:12px;"
					@cell-dblclick="copyText" :row-style="{height:`${ height }`}" :cell-style="{padding:'0px'}"
					@selection-change="handleSelectionChange()" highlight-current-row @row-click="onRowClick">

					<el-table-column prop="id" label="序号" width="50">
						<template slot-scope="scope">
							<span>{{(pages.page - 1) * pages.size + scope.$index + 1}}</span>
						</template>
					</el-table-column>

					<el-table-column prop="MenuCode" label="菜单编码" width="220">

					</el-table-column>
					<el-table-column prop="MenuName" label="菜单名称" width="250">
					</el-table-column>
					<el-table-column prop="FormName" label="菜单对应窗口名" width="350">
					</el-table-column>
					<el-table-column prop="Enabled" label="是否可用" width="150">
						<template slot-scope="scope">
							<img src="../assets/icon/iocn-seccess.png" style="width: 16px;height: 16px;"
								v-if="scope.row.Enabled == 1" />
							<img src="../assets/icon/icon-error.png" style="width: 16px;height: 16px;" v-else />
						</template>
					</el-table-column>
					<el-table-column prop="SortID" label="优先级" width="340">

					</el-table-column>
				</el-table>
			</div>
		</template>
		<Picturepreview :show="show" @hidefn="hidefn" ref="srcimg" :imgsrc="srcimg"></Picturepreview>
		<span v-if="FromUploadSetting">
			<input ref="filElem" id="filElem" :accept=" FromUploadSetting.accept" type="file" multiple="multiple"
				class="upload-file" @change="getFiles" style="display: none;" v-if="FromUploadSetting.multiple">
			<input ref="filElem" id="filElem" :accept=" FromUploadSetting.accept" type="file" class="upload-file"
				@change="getFile" style="display: none;" v-if="!FromUploadSetting.multiple">
		</span>

	</div>
</template>

<script>
	import CommonbtnUpLoad from '../components/common-upload.vue'
	import Picturepreview from '../components/picturepreview.vue'
	import DialogFrom from '../components/dialog-from.vue'
	import config from '../config/confighttp'
	export default {
		components: {
			CommonbtnUpLoad,
			Picturepreview,
			DialogFrom
		},
		props: {
			FromUploadSetting: {
				type: Object
			},
			// 文字颜色
			color: {
				type: String,
				default: '#000'
			},
			// 每一列的宽度
			width: {
				type: String,
				default: '2000px'
			},
			// 表格数据
			tableData: {
				type: Array,
				default: Array
			},
			// 表格头部数据
			headerData: {
				type: Array,
				default: Array
			},
			// 表格高度
			height: {
				type: String,
				default: ''
			},
			// 分类表格（通用7）
			colnum: {
				type: [String, Number],
				default: 7
			},
			// 点击变量
			onchange: {
				type: String,
				default: '-1'
			},
			// 
			types: {
				type: String,
				default: ''
			},
			// 合并单元格
			rowhe: {
				type: Boolean,
				default: false
			},
			selectabletype: {
				type: Number,
			},
			flag: {
				type: Boolean,
				default: true
			},
			// 单选绑定
			radioSelected: null,
			// 表格选中row数据
			multipleSelection: {},
			InvoiceChecked: {
				type: Number
			},
			CusFlag: {
				type: Number,
			},
			wtype: {
				type: Number
			},
			tableflag: {
				type: Boolean
			},
			tableflags: {
				type: Boolean
			},
			Quantityflag: {
				type: Boolean,
			},
			PTAOptionsDisabled: {
				type: Boolean,
				default: true
			},
			HPOptionsDisabled: {
				type: Boolean,
				default: true
			},
			DCBOptionsDisabled: {
				type: Boolean,
				default: true
			},
			GCBOptionsDisabled: {
				type: Boolean,
				default: true
			},
			GCOptionsDisabled: {
				type: Boolean,
				default: true
			},
			YCXOptionsDisabled: {
				type: Boolean,
				default: true
			},
			LNQNKZDGptionsDisabled: {
				type: Boolean,
				default: true
			},
			LNZZDGptionsDisabled: {
				type: Boolean,
				default: true
			},
			LNZCDGptionsDisabled: {
				type: Boolean,
				default: true
			},
			YDTLDYGptionsDisabled: {
				type: Boolean,
				default: true
			},
			PQDYGptionsDisabled: {
				type: Boolean,
				default: true
			},
			THQOptionsDisabled: {
				type: Boolean,
				default: true
			},
			QSZJOptionsDisabled: {
				type: Boolean,
				default: true
			},
			DetailRemarkdisabled: {
				type: Boolean,
				default: true
			},
			fontSizeTable: {
				type: Number,
				default: 14
			},
			widthselection: {
				type: Number,
			},
			loadingTable: {
				type: Boolean,
				default: true
			},
			isZheRan: {
				type: Boolean,
				default: false
			},
			auth: {
				type: Object,
				default: null
			},
			color: {
				type: Boolean,
				default: false
			},
			//单击整行是否 包含勾选复选框
			hasChecked: {
				type: Boolean,
				default: true
			},
			isLoading: {
				type: Boolean,
				default: false
			}
		},
		data: function() {
			return {
				loadingInstance: null,
				show: false,
				dialogVisiblesGetText: false,
				loading: this.loadingTable,
				pages: {
					page: 1,
					size: 10,
					total: 100
				},
				selectRow: [],
				selectData: [],
				_rowKeySeed: 1,
				setDatainv: "",
				srcimg: "",
				config: null
			}
		},
		created() {

		},
		mounted() {
			this.config = JSON.parse(JSON.stringify(config))
		},
		methods: {
			getCellColor(item, row) {
				if (item.prop === 'MFName' && this.color) {
					if (`${ row.MFCode }` === '102') {
						return 'red';
					}
					if (`${ row.MFCode }` === '101') {
						return '#3333ff';
					}
				}
				return this.getColor(row);
			},
			getColor(e) {
				if ((e.StatusName === '审核通过' || e.Status >= 30) && this.color) {
					return '#009933';
				} else if (e.StatusName === '待审' && e.MarkupRate && this.color) {
					return '#3333ff';
				} else if (e.color && this.color) {
					return e.color;
				} else {
					return '';
				}
			},
			textColor(e) {
				return e.Status >= 50 ? 'green' : e.Status == 15 ? 'red' : '';
			},
			cellStyle({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (row.IsUploadFile == 1 && row.Status != 30) {
					return 'color: #3333ff;padding:0px;'
				} else if (row.IsUploadFile == 1 && row.Status == 30) {
					return 'color: #009933;padding:0px;'
				} else {
					return 'padding:0px;'
				}
			},
			// 双击复制
			copyText(e, i) {
				this.copyToClipboard(e[i.property]);
			},
			copyToClipboard(text) {
				// 优先使用 Clipboard API
				if (navigator.clipboard && navigator.clipboard.writeText) {
					navigator.clipboard.writeText(text)
						.then(() => {
							this.$notify({
								title: '复制成功',
								message: `粘贴板：【${text}】`,
								type: 'success'
							})
						})
						.catch(err => {
							console.error('复制失败（Clipboard API），尝试使用 execCommand:', err);
							this.fallbackCopyToClipboard(text); // 回退到 execCommand
						});
				} else {
					// 如果不支持 Clipboard API，直接使用 execCommand
					this.fallbackCopyToClipboard(text);
				}
			},
			// 回退方法：使用 document.execCommand
			fallbackCopyToClipboard(text) {
				const textarea = document.createElement('textarea');
				textarea.value = text;
				textarea.style.position = 'fixed'; // 防止页面滚动
				textarea.style.opacity = 0; // 隐藏 textarea
				document.body.appendChild(textarea);

				textarea.select(); // 选中内容

				try {
					const successful = document.execCommand('copy');
					if (successful) {
						this.$notify({
							title: '复制成功',
							message: `粘贴板：【${text}】`,
							type: 'success'
						})
					} else {
						console.error('复制失败（execCommand）');
					}
				} catch (err) {
					console.error('复制失败（execCommand）:', err);
				} finally {
					document.body.removeChild(textarea); // 清理 DOM
				}
			},
			phonts(src) {
				this.show = true
				this.srcimg = src
			},
			hidefn() {
				this.show = false
			},
			Look(index, row) {
				this.$emit('Look', row)
			},
			Download(index, row) {
				this.$emit('Download', row)
			},
			UploadFiles(files, index, row) {
				this.$emit('Upload', {
					files: Array.from(files),
					index,
					row
				})
			},
			Confirm(index, row) {
				if (!row.CanConfirm) {
					return;
				}
				this.$emit('Confirm', row)
			},
			PrintClick(index, row) {
				this.$emit('PrintClick', row)
			},
			RemarkClick(index, row) {
				this.$emit('RemarkClick', row)
			},
			handleSelectionChange(val) {
				this.selectData = val;
				// 以数据打标记为准，避免快速全选/全不选时出现样式残留
				if (Array.isArray(this.tableData)) {
					this.tableData.forEach(row => {
						this.$set(row, "__rowChecked", false);
					});
				}
				if (Array.isArray(val)) {
					val.forEach(row => {
						this.$set(row, "__rowChecked", true);
					});
				}
				
				// 为了应对 Vue 内部引用地址变化和数组响应式问题
				// 强制在每一次选中变更时（特别是全不选时）立即重置一次背景记录
				this.selectRow = [];
				if (val && val.length > 0) {
					val.forEach((item, index) => {
						let rowIdx = this.tableData.indexOf(item);
						if (rowIdx !== -1) this.selectRow.push(rowIdx);
						if (item.DPMID) this.selectRow.push(item.DPMID);
						if (item.RowNo) this.selectRow.push(item.RowNo);
						if (item.ID) this.selectRow.push(item.ID);
						let obId = item.__ob__ && item.__ob__.dep ? item.__ob__.dep.id : null;
						if (obId) this.selectRow.push(obId);
						this.selectRow.push(item);
					});
				} else {
					this.currentRowIndex = -1;
				}

				// 强制在拦截阶段触发重排
				this.$nextTick(() => {
					try {
						// 触发 Vue 的响应式更新
						this.selectRow = [...this.selectRow];
						
						for (let child of this.$children) {
							if (child.$options._componentTag === 'el-table' || child.$options.name === 'ElTable') {
								child.$forceUpdate();
								break;
							}
						}
						
						if (this.$refs.multipleTable) {
							// 这个能够促使 element-ui 的 el-table 强制重绘画它的 class
							this.$refs.multipleTable.$forceUpdate();
						}
					} catch(e) {}
				});

				this.$emit("handleSelectionChange", val)
			},
			handleSelectionChangeUNQ(val, index) {
				this.$emit("handleSelectionChangeUNQ", val, index)
			},
			onRowClick(row) {
				this.currentRowIndex = row && row.row_index !== undefined ? row.row_index : -1;
				this.$emit("onRowClick", row || {});
			},
			onRowClick555(row) {
				this.$emit("onRowClick555", row || {});
			},
			onRowClick556(row) {
				this.$emit("onRowClick556", row || {});
			},
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				let rows = []
				// rows.a (rowIndex)
				if (this.rowhe) {
					if (rowIndex === this.tableData.length - 1) { //判断条件可以设置成你想合并的行的起始位置
						if (columnIndex === 2) { //判断条件可以设置成你想合并的列的起始位置
							return [2, 4];
						} else if (columnIndex === 1) {
							return [0, 0];
						}
					}
				}
			},
			changeTableSort(column) {
				this.$emit("changeTableSort", column)
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (row.InvoiceChecked == -1) {
					return "fpC0696B"
				}
				if (row.InvoiceChecked < 1 || row.InvoiceChecked >= 20) {
					return "fpRed"
				}
				if (row.IsUploadFileForColor == 1) {
					return "green"
				}
				return '';
			},
			tableRowClassName7({
				row,
				rowIndex
			}) {
				if (row.InvoiceChecked == -1) {
					return "fpC0696B"
				}
				if (row.InvoiceChecked < 1 || row.InvoiceChecked >= 20) {
					return "fpRed"
				}

				return '';
			},

			tableRowClassName522({
				row,
				rowIndex
			}) {
				if (row.IsUploadFileForColor == 1) {
					return "green"
				}
				return '';
			},
			// type = 3 的删除操作
			InvDel(SBPDID) {
				this.$emit('InvDel', SBPDID)
			},
			// 操作点击事件
			operation() {
				this.$emit('operation')
			},
			// style="display: inline-block;color: red;"  display: inline-block;color: #C0696B;
			tableRowClassNames({
				row,
				rowIndex
			}) {
				if (row.InvoiceChecked == -1) {
					return "fpC0696B"
				}
				if (row.InvoiceChecked < 1 || row.InvoiceChecked >= 20) {
					return "fpRed"
				}
			},
			RowKeys(row) {
				return this.getStableRowKey(row)
			},
			RowKeysSelect(row) {
				return this.getStableRowKey(row)
			},
			RowKeyIDsSelect522(row) {
				return this.getStableRowKey(row)
			},
			RowKeyIDsSelect556(row) {
				return this.getStableRowKey(row)
			},
			RowKeys81(row) {
				return this.getStableRowKey(row)
			},
			getStableRowKey(row) {
				const keyFields = ['InfoID', 'TVMID', 'SBMID', 'ID', 'SBDID', 'DPMID', 'DDCode', 'PDCode', 'CSMID', 'WHCode', 'HPID', 'CusCode', 'RowNo'];
				const data = Array.isArray(this.tableData) ? this.tableData : [];
				for (const field of keyFields) {
					const val = row && row[field];
					if (val === undefined || val === null || val === '') continue;
					const sameCount = data.reduce((count, item) => {
						return count + (item && item[field] === val ? 1 : 0);
					}, 0);
					if (sameCount === 1) {
						return `${field}:${val}`;
					}
				}
				if (row && row.__stableRowKey) {
					return row.__stableRowKey;
				}
				// 兜底：避免 _rowKeySeed 在异常场景下变成 undefined/NaN 导致重复 key（TMP:NaN）
				if (!Number.isFinite(this._rowKeySeed)) {
					this._rowKeySeed = 1;
				}
				const uid = `TMP:${this._rowKeySeed++}`;
				if (row) {
					this.$set(row, '__stableRowKey', uid);
				}
				return uid;
			},
			toggleRowSelection(row, selected) {
				console.log(111, row.IsRelationProvince, selected);
				this.$refs.multipleTable.toggleRowSelection(row, selected);
			},
			rowClass({
				row,
				rowIndex
			}) {
				if (row.__rowChecked === true) {
					return {
						"background-color": "#E5E9F2"
					}
				}
			},
			rowClassSelect({
				row,
				rowIndex
			}) {
				if (row.__rowChecked === true) {
					return {
						"background-color": "#E5E9F2"
					}
				}
			},
			cancelGetText() {
				this.dialogVisiblesGetText = false
			},
			dialogOKGetText() {
				this.dialogVisiblesGetText = false
			},
			GetTextClick() {
				this.dialogVisiblesGetText = true
			},
			cz(ID) {
				this.$emit('cz', ID)
			},
			TaxUnitPriceChange(e, row) {
				let par = {
					e: e,
					row: row
				}
				this.$emit('TaxUnitPriceChange', par)
			},
			Quantity522(e, o) {
				let obj = {
					e: e,
					o: o
				}
				this.$emit("Quantity522", obj)
			},
			zheRChange(e, o) {
				console.log(e, o)
				let obj = {
					e: e,
					o: o
				}
				if (!o.Sum.includes('-')) {
					o.Sum = '-1';
					return;
				}
				//this.$emit("zheRChange", obj)
			},
			operationDownload(row) {
				this.$emit("operationDownload", row)
			},
			showPdf(url) {
				window.open(url);
			},
			ReasonTips(row) {
				this.$emit("reasonTips", row)
			},
			CZClick(index, row, item) {
				if (item.clickName == 'Upload') {
					this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
				}
				let obj = {
					index,
					row,
					item
				}
				this.$emit('CZClick', obj)
			},
			getFile(e) {
				const inputFile = e.target.files[0];
				this.$emit('getFile', inputFile)
				// input[file]标签防重复问题
				e.target.value = ""
			},
			getFiles(e) {
				const inputFile = e.target.files;
				console.log('进来了----------');
				console.log(inputFile, 'inputFile');
				this.$emit('getFiles', inputFile)
				// input[file]标签防重复问题
				e.target.value = ""

			},
			handckChange(e, i) {
				i.NeedShowOffice = e ? 1 : 0;
				this.$forceUpdate();
			},
			parseMoney(num) {
				if (num && num != null) {
					num = String(num);
					var left = num.split('.')[0],
						right = num.split('.')[1];
					right = right ? (right.length >= 2 ? '.' + right.substr(0, 2) : '.' + right + '0') : ''; //.00
					var temp = left.split('').reverse().join('').match(/(\d{1,3})/g);
					return (Number(num) < 0 ? "-" : "") + temp.join(',').split('').reverse().join('') + right;
				} else if (num === 0) {
					return '0';
				} else {
					return "";
				}
			},
			parseText(k, i) {
				if (i[k] === 0) {
					return 0;
				}
				if (!i[k]) {
					return '';
				}
				if (k.includes('Ratio')) {
					return i[k] + (k.includes('RatioThd') ? '‰' : '%');
				} else if ((k.includes('Quota') || k.includes('Sales')) && !isNaN(Number(i[k]))) {
					return this.parseMoney(i[k]);
				} else {
					return i[k];
				}
			},
			openLoading() {
				this.loadingInstance = this.$loading({
					target: this.$el.querySelector('.el-table') || this.$el,
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(255, 255, 255, 0.7)'
				});
			},
			closeLoading() {
				if (this.loadingInstance) {
					this.loadingInstance.close();
				}
			}
		},
		watch: {
			isLoading: {
				handler(val) {
					this.loading = val;
				},
				immediate: true
			},
			loading: {
				handler(val) {
					if (val) {
						this.openLoading();
					} else {
						this.closeLoading();
					}
				},
				immediate: true
			},
			selectData: {
				handler(data) {
					this.selectRow = [];
					if (data && data.length > 0) {
						data.forEach((item, index) => {
							let rowIdx = this.tableData.indexOf(item);
							if (rowIdx !== -1) this.selectRow.push(rowIdx);
							
							if (item.DPMID) this.selectRow.push(item.DPMID);
							if (item.RowNo) this.selectRow.push(item.RowNo);
							if (item.ID) this.selectRow.push(item.ID);
							
							if (item.__ob__ && item.__ob__.dep && item.__ob__.dep.id) {
								this.selectRow.push(item.__ob__.dep.id);
							}
							
							this.selectRow.push(item);
						});
						
						// 兼容：当全选/反选时，如果选中了数据，将最后一条设为当前高亮行
						// 如果清空了数据，则取消高亮行
						try {
							for (let child of this.$children) {
								if ((child.$options._componentTag === 'el-table' || child.$options.name === 'ElTable') && child.setCurrentRow) {
									let lastItem = data[data.length - 1];
									this.currentRowIndex = lastItem.row_index;
									child.setCurrentRow(lastItem);
								}
							}
						} catch (e) {}
					} else {
						this.currentRowIndex = -1;
						try {
							for (let child of this.$children) {
								if ((child.$options._componentTag === 'el-table' || child.$options.name === 'ElTable') && child.setCurrentRow) {
									child.setCurrentRow();
								}
							}
						} catch (e) {}
					}
					
					// 强制刷新表格以应用最新的 rowClass
					this.$nextTick(() => {
						try {
							// 触发 Vue 的响应式更新
							this.selectRow = [...this.selectRow];
							
							for (let child of this.$children) {
								if (child.$options._componentTag === 'el-table' || child.$options.name === 'ElTable') {
									child.$forceUpdate();
									if (child.doLayout) {
										child.doLayout();
									}
									break;
								}
							}
							
							if (this.$refs.multipleTable) {
								this.$refs.multipleTable.$forceUpdate();
								if (this.$refs.multipleTable.doLayout) {
									this.$refs.multipleTable.doLayout();
								}
							}
						} catch(e) {}
					});
				},
				deep: true
			},
			tableData: {
				handler(newVal, oldVal) {
					// 数据源切换时重置勾选标记，避免跨批次残留背景色
					if (Array.isArray(newVal)) {
						newVal.forEach(row => {
							if (row && row.__rowChecked) {
								this.$set(row, "__rowChecked", false);
							}
						});
					}
					if (this.loadingTable) {
						if (newVal) {
							this.loading = false
						} else {
							this.loading = true
						}
					} else {
						this.loading = false;
					}
				},
				deep: true,
				// immediate: true
			}
		}
	}
</script>

<style lang="less" scoped>
	// @font-face {
	//     font-family: 'myFont';
	//     src: url("../assets/font/PingFang/苹方黑体-中黑-简.ttf"); //你的资源目录
	//     font-weight: normal;
	//     font-style: normal;
	//   }
	.aclick {
		display: inline-block;
		font-size: 14px;
		color: #333333;
		text-decoration: underline;
		cursor: pointer;
	}

	.disabled {
		color: #cccccc;
		cursor: not-allowed;
	}

	/deep/.el-table .fpRed {
		color: red !important;
	}

	/deep/.el-table .fpC0696B {
		color: #c0696b !important;
	}

	/deep/.el-table .green {
		color: rgb(5, 206, 5) !important;
	}

	table {
		border-collapse: collapse;
		border-spacing: 0;
		// width: 100%;
	}

	tr:nth-child(odd) {
		background-color: #fafafa;
	}

	tr:nth-child(even) {
		background-color: #ffffff;
	}

	table tbody tr .activetable {
		background-color: #00266d;
		color: #fff;
	}

	// 表格单元格的高度
	.all {

		/deep/.el-table .cell,
		.el-table--border .el-table__cell:first-child .cell {
			padding-left: 10px;
			height: 32px;
			line-height: 32px;
		}
	}

	/deep/.has-gutter tr th {
		border-color: #f0f0f0;
		padding: 0px;
		font-size: 14px;
		color: #333333;
		background-color: #f0f0f0;
	}

	// 添加颜色类
	/deep/.el-radio__input.is-checked+.el-radio__label {
		color: #e71d43 !important;
	}

	/deep/.el-radio__input.is-checked .el-radio__inner {
		background: #e71d43 !important;
		border-color: #e71d43 !important;
	}

	/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
	.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #e71d43;
		border-color: #e71d43;
	}

	/deep/.el-checkbox__input.is-checked+.el-checkbox__label {
		color: #e71d43;
	}

	/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #e71d43;
		border-color: #e71d43;
	}

	/deep/.el-checkbox.is-bordered.is-checked {
		border-color: #e71d43;
	}

	/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #e71d43;
	}

	/deep/.el-input.el-input--suffix .el-input__inner {
		// width: 140px;
		height: 28px;
		background: #ffffff;
		border-radius: 2px;
		border: 1px solid #e6e8eb;
	}

	/deep/.el-input__suffix .el-input__icon {
		height: 100%;
		width: 25px;
		text-align: center;
		transition: all 0.3s;
		line-height: 28px;
	}

	a {
		color: #e71d43;
		margin-left: 20px;
		text-decoration: none;
	}

	.operation {
		display: inline-block;
		font-size: 14px;
		margin-left: 10px;
		color: #e71d43;
		text-decoration: none;
		cursor: pointer;
	}

	.cell-input {
		width: 100%;
		height: 100%;
		border: 0;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		padding-left: 10px;
		padding-right: 10px;
		box-sizing: border-box;
		color: #606266;
		opacity: 0;

		&:focus {
			border: 1px solid rgb(231 29 67);
			color: rgb(231 29 67);
			background: #fff;
			opacity: 0.9;
		}
	}

	.item-input {
		width: 100%;
		height: 100%;
		border: 0;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		padding-left: 10px;
		padding-right: 10px;
		box-sizing: border-box;
		color: #606266;
	}

	a {
		display: inline-block;
		font-size: 14px;
		margin-left: 10px;
		color: #00266d;
		text-decoration: underline;
		cursor: pointer;
	}

	/deep/.jv-node {
		font-size: 12px !important;
	}

	.UnitPriceCss {
		display: inline-block;
		float: right;
	}

	.all {}

	/deep/.el-table__header thead tr th {
		border-color: rgb(240 240 240);
		padding: 0px;
		font-size: 14px;
		color: rgb(51 51 51);
		background-color: rgb(240 240 240);

		.cell {
			padding-left: 10px;
			height: 32px;
			line-height: 32px;
		}
	}

	/*去掉表格单元格边框*/
	/deep/.customer-no-border-table th {
		border: none;
	}

	/deep/.customer-no-border-table td,
	.customer-no-border-table th.is-leaf {
		border: none;
	}

	/*表格最外边框*/
	/deep/.customer-no-border-table .el-table--border,
	.el-table--group {
		border: none;
	}

	/*头部边框*/
	/deep/.customer-no-border-table thead tr th.is-leaf {
		border: 0px solid #ebeef5;
		// border-right: none;
		margin-left: -10px;
	}

	/deep/.customer-no-border-table thead tr th:nth-last-of-type(2) {
		border-right: 0px solid #ebeef5;
	}

	/*表格最外层边框-底部边框*/
	/deep/.customer-no-border-table .el-table--border::after,
	.customer-no-border-table .el-table--group::after {
		width: 0;
	}

	/deep/.customer-no-border-table::before {
		width: 0;
	}

	/deep/.customer-no-border-table .el-table__fixed-right::before,
	.el-table__fixed::before {
		width: 0;
	}

	/deep/.customer-no-border-table .el-table__header tr th {
		background: #fff;
		color: #333333;
		padding: 0px;
		fontweight: 550;
		height: 36px;
		border: 0px;
		font-size: 15px;
	}

	/*去掉鼠标悬停背景颜色*/
	/deep/.customer-no-border-table .el-table__body tr.current-row>td {
		background-color: transparent !important;
		color: #00266d;
	}

	/deep/.customer-no-border-table .all .el-table .cell {
		height: 32px;
		line-height: 32px;
	}
</style>
